import { render, staticRenderFns } from "./BeautyMakeup.vue?vue&type=template&id=052443d2&scoped=true"
import script from "./BeautyMakeup.vue?vue&type=script&lang=js"
export * from "./BeautyMakeup.vue?vue&type=script&lang=js"
import style0 from "./BeautyMakeup.vue?vue&type=style&index=0&id=052443d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052443d2",
  null
  
)

export default component.exports